<template>
  <div class="tw:flex tw:items-start tw:gap-3">
    <Toggle :id="id" v-model="isOn" class="tw:mt-0.5" />
    <label :for="id" class="tw:mb-0 tw:cursor-pointer tw:font-normal">
      <span class="tw:block tw:text-sm tw:font-medium">
        <slot />
      </span>
      <span v-if="$slots.description" class="tw:block tw:text-sm tw:text-muted-foreground">
        <slot name="description" />
      </span>
    </label>

    <!-- A switch is a button, which a plain form does not submit: the hidden input
         carries its state to the server. -->
    <input
      v-if="isOn || uncheckedValue !== null"
      type="hidden"
      :name="name"
      :value="isOn ? value : uncheckedValue"
    >
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import Toggle from '@/components/ui/Toggle.vue'

interface Props {
  id: string
  name: string
  value?: string
  checked?: boolean
  /** Submitted when the switch is off; null submits nothing, as a checkbox does. */
  uncheckedValue?: string | null
}

const props = withDefaults(defineProps<Props>(), {
  value: '1',
  checked: false,
  uncheckedValue: null,
})

const isOn = ref(props.checked)
</script>
